<template>
  <div v-show="isShowconfirm" class="compensation-request">
    <div class="row mb-3">
      <div class="col-12">
        {{ lang.monetary_compensation_new.SUM_REQUEST }}
      </div>
    </div>
    <div class="content-request mb-5">
      <div class="row mb-2 align-items-center">
        <div class="col-5">{{ lang.monetary_compensation_new.ISSUE_DATE }}</div>
        <div class="col-7">{{ moment(infoCashOrder.updated_at).format('DD-MM-YYYY HH:mm:ss') }}</div>
      </div>
      <div class="row mb-2 align-items-center">
        <div class="col-5">{{ lang.monetary_compensation_new.COMPENSATION_AMOUNT }}</div>
        <div class="col-7">
          {{ monetary?.currency }}
          {{ infoCashOrder.open_amount > 0 ? infoCashOrder.open_amount : infoCashOrder.compensation_amount }}
        </div>
      </div>
      <div class="row mb-2 align-items-center">
        <div class="col-5">{{ lang.monetary_compensation_new.COMPENSATION_TYPE }}</div>
        <div class="col-7">
          <span v-if="infoCashOrder.methode_get == 1">{{ lang.monetary_compensation_new.COMPENSATION_TYPE_1 }}</span>
          <span v-if="infoCashOrder.methode_get == 2">{{ lang.monetary_compensation_new.COMPENSATION_TYPE_2 }}</span>
          <span v-if="infoCashOrder.methode_get == 3">{{ lang.monetary_compensation_new.COMPENSATION_TYPE_3 }}</span>
        </div>
      </div>
      <div v-if="infoCashOrder.methode_get == 1" class="row mb-2 align-items-center">
        <div class="col-5">{{ lang.monetary_compensation_new.COMPENSATION_OPTION }}</div>
        <div class="col-7">
          <span v-if="infoCashOrder.compensation_option == 0">
            {{ lang.monetary_compensation_new.COMPENSATION_OPTION_1 }}
          </span>
          <span v-if="infoCashOrder.compensation_option == 1">
            {{ lang.monetary_compensation_new.COMPENSATION_OPTION_2 }}
          </span>
        </div>
      </div>
      <div v-if="infoCashOrder.compensation_option == 1" class="row mb-2 align-items-center">
        <div class="col-5">{{ lang.monetary_compensation_new.CASH_PICK_UP_ORDER }}</div>
        <div class="col-7">{{ infoCashOrder.currency }} {{ infoCashOrder.amount_cash }}</div>
      </div>
      <div v-if="infoCashOrder.compensation_option == 1" class="row mb-2 align-items-center">
        <div class="col-5">{{ lang.monetary_compensation_new.OPEN_AMOUNT }}</div>
        <div class="col-7">
          {{ infoCashOrder.currency }}
          <span v-if="infoCashOrder.open_amount > 0">
            {{ infoCashOrder.open_amount - infoCashOrder.amount_cash }}
          </span>
          <span v-else>{{ infoCashOrder.compensation_amount - infoCashOrder.amount_cash }}</span>
        </div>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-3 text-center">
        <button class="btnDefault" @click="processConfirm(0)">{{ lang.monetary_compensation_new.BACK }}</button>
      </div>
      <div class="col-9 text-center">
        <button class="btnDefault" @click="processConfirm(5)">{{ lang.monetary_compensation_new.CONFIRM_REQUEST }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    infoCashOrder: {
      type: Object,
      default: () => {}
    },
    service: {
      type: Object,
      default: () => {}
    },
    monetaryId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isShowconfirm: false
    }
  },
  computed: {
    monetary() {
      return _.find(this.service.list_monetary, { id: parseInt(self.monetaryId) })
    }
  },
  created() {
    this.processConfirm(5)
  },
  methods: {
    processConfirm: function (e) {
      this.$emit('processConfirm', e)
    }
  }
}
</script>
